import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=0fdb86a8&lang=pug"
import script from "./Centered.vue?vue&type=script&lang=ts"
export * from "./Centered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports